
import { oz } from '@weft/utils';
import { SYNC_STATUSES } from '../../primitives';
import { ApiDateSchema, ObjectIdSchema, SyncStatusSchema } from '../../primitives';
import { ContractStatusSchema } from './contract-status-schema';

export const NewContractSchema = oz.object({
  startDate: ApiDateSchema,
  endDate: ApiDateSchema.optional(),
  planId: ObjectIdSchema,
  customerId: ObjectIdSchema,
  crmId: oz.string().nullish(),
  status: ContractStatusSchema,
  trialEndDate: ApiDateSchema.optional(),
  cancelledAt: ApiDateSchema.optional(),
  syncStatus: SyncStatusSchema.default(SYNC_STATUSES.None),
  syncStatusUpdatedAt: ApiDateSchema.optional(),
}).openapi('NewContract');

export type NewContract = oz.infer<typeof NewContractSchema>;